// extracted by mini-css-extract-plugin
export default {"dashed":"style_dashed__yFkqh","base":"style_base__tVUax"};